var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white"},[_c('div',{staticClass:"empty-modal"},[_c('img',{attrs:{"src":"static/images/icons/blank.png"}}),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }